import React, { FC, useEffect } from "react";
import { ThemeUIProvider, useThemeUI } from "theme-ui";
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThemeProviderProps } from "@theme-ui/core";
import { fontLoader } from "./font-loader";
import { themeBuilder } from "../util/theme-builder";
import "normalize.css";
import "../presets/css/main.scss";

type KameleonThemeProviderProps = {
  // Append other props
} & ThemeProviderProps;

const KameleonThemeProvider: FC<KameleonThemeProviderProps> = ({
  children,
  theme,
}: KameleonThemeProviderProps) => {
  const themeContext = useThemeUI();
  const isInnerTheme = typeof theme === "function";

  useEffect(() => {
    if (!isInnerTheme) fontLoader(theme);
    if (themeContext.theme) fontLoader(themeContext.theme);
  }, [themeContext, theme]);

  // Either render the theme directly (inner theme) or using a functional (outer theme) theme
  // https://theme-ui.com/guides/nested-theme-providers#functional-themes
  // Mostly, the outer theme (base theme) is rendered on the "highest" level
  const themeToLoad = isInnerTheme ? theme : themeBuilder(theme);

  return <ThemeUIProvider theme={themeToLoad}>{children}</ThemeUIProvider>;
};

export { KameleonThemeProvider };
